export const Routes = {
  MAIN: '/',
  TEST: '/test',
  LOGIN: '/auth',
  TRACKING: '/tracking',
  FILE_UPLOAD: '/file-upload',
  ICONS: '/icons',
};
